(() => {
  if (window.orelvonFreeLighting) return;
  const instances = new Map();
  const intervalMs = 6000;
  const fadeMs = 800;
  const firstRoomIds = [1, 24, 34, 2, 4, 19, 43, 11, 16, 6, 7];
  const containPhotoIds = new Set([35, 41, 44]);
  const photoPositions = {
    1: '50% 35%',
    2: '50% 25%',
    3: '50% 72%',
    4: '50% 50%',
    5: '50% 25%',
    6: '50% 30%',
    7: '50% 20%',
    8: '50% 65%',
    9: '50% 35%',
    10: '50% 50%',
    11: '50% 20%',
    12: '50% 38%',
    13: '100% 50%',
    14: '50% 35%',
    15: '50% 0%',
    16: '50% 20%',
    17: '50% 50%',
    18: '50% 25%',
    19: '50% 35%',
    20: '50% 35%',
    21: '50% 50%',
    22: '50% 25%',
    23: '50% 25%',
    24: '50% 25%',
    25: '50% 25%',
    26: '50% 50%',
    27: '50% 15%',
    28: '50% 50%',
    29: '50% 0%',
    30: '50% 50%',
    31: '50% 20%',
    32: '50% 50%',
    33: '50% 20%',
    34: '50% 50%',
    35: '50% 50%',
    36: '65% 50%',
    37: '50% 60%',
    38: '50% 50%',
    39: '50% 20%',
    40: '50% 50%',
    41: '50% 50%',
    42: '50% 25%',
    43: '50% 50%',
    44: '50% 50%',
    45: '50% 35%',
    46: '50% 35%',
  };

  function createCarousel(root) {
    if (instances.has(root)) return;
    const carousel = root.querySelector('[data-olfh-carousel]');
    const photoData = root.querySelector('[data-olfh-photos]');
    const copyData = root.querySelector('[data-olfh-copy]');
    if (!carousel || !photoData || !copyData) return;
    let photos;
    let copy;
    try {
      photos = JSON.parse(photoData.textContent);
      copy = JSON.parse(copyData.textContent);
    } catch {
      return;
    }
    const byId = new Map(photos.map(photo => [photo.id, photo]));
    const roomPhotos = [
      ...firstRoomIds.map(id => byId.get(id)).filter(Boolean),
      ...photos.filter(photo => photo.category !== 'outdoor' && photo.category !== 'installation' && !firstRoomIds.includes(photo.id)),
      ...photos.filter(photo => photo.category === 'installation'),
    ];
    const outdoorPhotos = photos.filter(photo => photo.category === 'outdoor').sort((a, b) => a.id - b.id);
    if (!roomPhotos.length || !outdoorPhotos.length) return;
    const pairs = roomPhotos.map((room, index) => ({ room, outdoor: outdoorPhotos[index % outdoorPhotos.length] }));
    const diptych = carousel.querySelector('[data-olfh-diptych]');
    const controls = carousel.querySelector('.olfh__controls');
    const toggle = carousel.querySelector('[data-olfh-toggle]');
    const counter = carousel.querySelector('[data-olfh-counter]');
    const status = carousel.querySelector('[data-olfh-status]');
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    let reducedMotion = media.matches;
    let autoplay = !reducedMotion;
    let index = 0;
    let revision = 0;
    let timer;
    let fadeTimer;
    let inView = !('IntersectionObserver' in window);
    let focusWithin = false;
    let destroyed = false;
    const removers = [];

    function listen(target, event, callback) {
      target.addEventListener(event, callback);
      removers.push(() => target.removeEventListener(event, callback));
    }

    function contained(photo) {
      return containPhotoIds.has(photo.id);
    }

    function createImage(photo, className) {
      const image = document.createElement('img');
      image.className = `olfh__image ${className}${contained(photo) ? ' is-contained' : ''}`;
      image.style.objectPosition = photoPositions[photo.id] || '50% 50%';
      image.src = photo.url;
      image.alt = photo.title;
      image.width = photo.width;
      image.height = photo.height;
      image.draggable = false;
      image.decoding = 'async';
      return image;
    }

    function presentation(image, photo) {
      if (!contained(photo)) return image;
      const panel = document.createElement('div');
      panel.className = image.className;
      panel.dataset.photoUrl = photo.url;
      const backdrop = document.createElement('span');
      backdrop.className = 'olfh__backdrop';
      backdrop.style.backgroundImage = `url("${photo.url}")`;
      backdrop.setAttribute('aria-hidden', 'true');
      image.className = 'olfh__contained-photo';
      panel.append(backdrop, image);
      return panel;
    }

    function loadImage(photo) {
      const image = createImage(photo, 'is-current');
      if (image.complete) return Promise.resolve(image.naturalWidth > 0 ? image : null);
      return new Promise(resolve => {
        image.addEventListener('load', () => resolve(image), { once: true });
        image.addEventListener('error', () => resolve(null), { once: true });
      });
    }

    function updateControls() {
      counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(pairs.length).padStart(2, '0')}`;
      counter.setAttribute('aria-label', `${copy.pair} ${index + 1} ${copy.of} ${pairs.length}`);
      toggle.textContent = autoplay ? copy.pause : copy.play;
      toggle.setAttribute('aria-label', autoplay ? copy.pause_label : copy.play_label);
      status.textContent = !autoplay ? copy.paused : focusWithin ? copy.using_photos : document.hidden ? copy.inactive : !inView ? copy.out_of_view : copy.autoplay;
      carousel.classList.toggle('has-reduced-motion', reducedMotion);
    }

    function schedule() {
      window.clearTimeout(timer);
      updateControls();
      if (destroyed || !autoplay || focusWithin || document.hidden || !inView) return;
      timer = window.setTimeout(() => show(index + 1), intervalMs);
    }

    async function show(target) {
      window.clearTimeout(timer);
      const change = ++revision;
      const nextIndex = (target + pairs.length) % pairs.length;
      const next = pairs[nextIndex];
      const images = await Promise.all([loadImage(next.room), loadImage(next.outdoor)]);
      if (destroyed || change !== revision) return;
      if (images.some(image => !image)) {
        schedule();
        return;
      }
      window.clearTimeout(fadeTimer);
      ['room', 'outdoor'].forEach((side, position) => {
        const figure = carousel.querySelector(`[data-olfh-side="${side}"]`);
        const frame = figure.querySelector('[data-olfh-frame]');
        const current = frame.querySelector('.is-current');
        const photo = next[side];
        const image = presentation(images[position], photo);
        frame.querySelectorAll('.is-previous').forEach(previous => previous.remove());
        if (current && (current.getAttribute('src') || current.dataset.photoUrl) === photo.url) return;
        if (current && !reducedMotion) {
          current.classList.remove('is-current', 'is-entering');
          current.classList.add('is-previous');
          current.setAttribute('aria-hidden', 'true');
          image.classList.add('is-entering');
          frame.append(image);
        } else {
          frame.replaceChildren(image);
        }
      });
      index = nextIndex;
      ['room', 'outdoor'].forEach(side => {
        const figure = carousel.querySelector(`[data-olfh-side="${side}"]`);
        const photo = pairs[index][side];
        const category = copy.categories[photo.category] || photo.category;
        figure.querySelector('[data-olfh-category]').textContent = category;
        figure.querySelector('[data-olfh-caption]').textContent = copy.captions[photo.id] || photo.title;
        figure.setAttribute('aria-label', `${category}, ${copy.pair.toLowerCase()} ${index + 1} ${copy.of} ${pairs.length}`);
      });
      fadeTimer = window.setTimeout(() => {
        if (!destroyed && change === revision) {
          carousel.querySelectorAll('.is-previous').forEach(image => image.remove());
          carousel.querySelectorAll('.is-entering').forEach(image => image.classList.remove('is-entering'));
        }
      }, reducedMotion ? 0 : fadeMs + 50);
      schedule();
    }

    listen(carousel.querySelector('[data-olfh-previous]'), 'click', () => show(index - 1));
    listen(carousel.querySelector('[data-olfh-next]'), 'click', () => show(index + 1));
    listen(toggle, 'click', () => { autoplay = !autoplay; schedule(); });
    listen(carousel, 'keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(index + (event.key === 'ArrowLeft' ? -1 : 1));
    });
    listen(diptych, 'focusin', () => { focusWithin = true; schedule(); });
    listen(diptych, 'focusout', event => {
      if (!diptych.contains(event.relatedTarget)) { focusWithin = false; schedule(); }
    });
    listen(document, 'visibilitychange', schedule);
    listen(media, 'change', () => {
      reducedMotion = media.matches;
      if (reducedMotion) autoplay = false;
      schedule();
    });
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting && entry.intersectionRatio > 0;
        schedule();
      }, { threshold: [0, 0.0001] });
      observer.observe(diptych);
    }
    instances.set(root, () => {
      destroyed = true;
      revision += 1;
      window.clearTimeout(timer);
      window.clearTimeout(fadeTimer);
      observer?.disconnect();
      removers.forEach(remove => remove());
      instances.delete(root);
    });
    controls.hidden = false;
    schedule();
  }

  function initialize(scope) {
    if (scope.matches?.('[data-olfh-section]')) createCarousel(scope);
    scope.querySelectorAll('[data-olfh-section]').forEach(createCarousel);
  }

  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of instances) {
      if (event.target === root || event.target.contains(root)) destroy();
    }
  });
  window.orelvonFreeLighting = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
})();
